import { memo } from 'react';
import { queryClient } from '@/lib/react-query';
import { QueryClientProvider } from '@tanstack/react-query';

const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

// Memoize to prevent unnecessary re-renders
export default memo(ReactQueryProvider);
